import latencyJSON from "./latency.json";

/**
 * Fixture used by `MockApiTransport` (`?mock=1`) — imported directly from
 * `latency.json` (`{env, file, label, metric, data: [{latencybucket,
 * frequency}, ...]}`), the same envelope shape `LatencyDataService` parses
 * from the real API response, so the mock stays a faithful copy of the
 * real export instead of a hand-typed duplicate that can drift from it.
 */
export const mockLatencyData = latencyJSON;
